'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, event_id, aid, medalRound) {
  return function (dispatch) {
    return dispatch(_defineProperty({
      feis_id: feis_id,
      event_id: event_id,
      aid: aid,
      medalRound: medalRound

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisEventsPrefix)(feis_id) + '/' + event_id + '/adjudicators/' + aid + '/associate-medal-round',
        method: 'POST',
        data: { medalRound: medalRound }
      },
      types: ['ASSOCIATE_MEDAL_ROUND_WITH_ADJUDICATOR_START', 'ASSOCIATE_MEDAL_ROUND_WITH_ADJUDICATOR', 'ASSOCIATE_MEDAL_ROUND_WITH_ADJUDICATOR_ERROR']
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/associateMedalRoundWithAdjudicator.js
// module id = 626
// module chunks = 0